<template>
  <div class="NotFound">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card
            height="100vh"
            color="transparent"
            flat
            class="d-flex flex-column align-center justify-center"
          >
            <div class="display-3 mt-5">Page not found.</div>
            <div class="grey--text lighten-5">
              We can find the page you are looking for
            </div>
            <div class="paragraph-text"><br />Try going back to home page.</div>
            <v-btn color="primary" to="/dashboard">Home</v-btn>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PageNotFound"
};
</script>

<style>
.paragraph-text {
  font-size: 18px;
}
</style>
